import { useContext, useDebugValue } from "react";
import WebsocketContext from "../context/WebsocketProvider";
import { WebsocketProvider } from "../context/WebsocketProvider";

// Hook to use the use context 
const useSocket = () => {
    return useContext(WebsocketContext);
}

export default useSocket;